import gql from 'graphql-tag'

export default gql`
	mutation updateRangeLoyaltyCards($ids: RangeIds!, $fields: LoyaltyCardFields, $transactionFields: RangeLoyaltyCardFields) {
		cashAssist {
			updateRangeLoyaltyCards(ids: $ids, fields: $fields, transactionFields: $transactionFields)
		}
	}
`
